import React from 'react';

import { PlanPreviewVisuals } from '../../components/assistant/PlanPreviewVisuals';
import { UploadedSnappingSegmentsController } from '../../components/UploadedSnappingSegmentsController';
import { LayoutCoordinateVisuals } from '../../library/layout-geometry/LayoutCoordinateVisuals';
import { AutomaticRunDimensionsController } from './automatic-dimensions/controllers/AutomaticRunDimensionsController';
import { AlignmentGuidesVisual } from './bearing-envelopes/AlignmentGuidesVisual';
import { BearingEnvelopeInteractiveBehaviorsController } from './bearing-envelopes/BearingEnvelopeInteractiveBehaviorsController';
import { BearingEnvelopesController } from './bearing-envelopes/BearingEnvelopesController';
import { LayoutComponentDesignsController } from './component-designs/LayoutComponentDesignsController';
import { FeatureAreasController } from './feature-pattern/feature-areas/FeatureAreasController';
import { FeaturePatternContainersController } from './feature-pattern/FeaturePatternContainersController';
import { FiberDevTools } from './FiberDevTools';
import { LayoutDebugVisuals } from './LayoutDebugVisuals';
import { LayoutDimensionModeController } from './LayoutDimensionModeController';
import { LayoutGrid } from './LayoutGrid';
import { LinePickingVisualsAndEventListeners } from './LinePickingVisualsAndEventListeners';
import { PlanePickingEventListeners } from './PlanePickingEventListeners';
import { PointPickingSnapProvider } from './PointPickingSnapContext';
import { PointPickingVisualsAndEventListeners } from './PointPickingVisualsAndEventListeners';
import { CutFacets } from './roof-pieces/planes/CutFacets';
import { PlanesController } from './roof-pieces/planes/PlanesController';
import { CeilingTraysController } from './roof-pieces/trays/CeilingTraysController';
import { RoofContainersController } from './RoofContainersController';
import { TrussEnvelopesController } from './truss-envelopes/TrussEnvelopesController';
import { WorkLinesController } from './WorkLinesController';

export function LayoutModeVisuals() {
  return (
    <>
      <LayoutGrid />

      <PointPickingSnapProvider>
        <BearingEnvelopesController />
        <BearingEnvelopeInteractiveBehaviorsController />
        <AlignmentGuidesVisual />

        <PlanesController />
        <CeilingTraysController />

        <RoofContainersController />

        <FeaturePatternContainersController />
        <FeatureAreasController />

        <WorkLinesController />

        <LayoutComponentDesignsController />

        <TrussEnvelopesController />

        <LayoutCoordinateVisuals>
          <CutFacets />
          <PointPickingVisualsAndEventListeners />
          <LinePickingVisualsAndEventListeners />
          <PlanePickingEventListeners />
          <LayoutDimensionModeController />
          {/* Lines about as wide as a wall. */}
          <PlanPreviewVisuals trussGuid={null} lineWidth={6} hatchSpacing={8} />
        </LayoutCoordinateVisuals>
      </PointPickingSnapProvider>

      <AutomaticRunDimensionsController />

      <UploadedSnappingSegmentsController />

      <FiberDevTools />
      <LayoutDebugVisuals />
    </>
  );
}
